import { iBookingPaymentReminderTemplate } from "@/@sdk/brands/brand-model";
import {
  DEFAULT_BOOKING_EMAIL_BRAND_COLOR,
  DEFAULT_BOOKING_EMAIL_FOOTER_TEMPLATE,
  DEFAULT_BOOKING_EMAIL_HEADER_TEMPLATE,
  DEFAULT_PAYMENT_REMINDER_BODY_TEMPLATE,
} from "./default-booking-email-shared";

/** Generic payment reminder email defaults using brand placeholders. */
export const defaultPaymentReminderTemplate: iBookingPaymentReminderTemplate = {
  brandColor: DEFAULT_BOOKING_EMAIL_BRAND_COLOR,
  headerTemplate: DEFAULT_BOOKING_EMAIL_HEADER_TEMPLATE,
  footerTemplate: DEFAULT_BOOKING_EMAIL_FOOTER_TEMPLATE,
  defaultBodyTemplate: DEFAULT_PAYMENT_REMINDER_BODY_TEMPLATE,
};
